import React, { Component } from 'react';
import axios from 'axios';
import pdfMake from 'pdfmake';
import { debounce, get } from 'lodash';
import html2canvas from 'html2canvas';
import { API_HOST } from '../../consts';
import { Form } from 'informed';
import HeaderDr from '../../components/HeaderDr';
import ComplexPieChart from './ComplexPieChart.js';
import ComplexBarChart from './ComplexBarChart';
import ComplexBarChartTCT from './ComplexBarChartTCT';
import ComplexLineChart from './ComplexLineChart';
import ReportGraphLine from './ReportGraphLine';
import {
  Grid,
  IconButton,
  Button,
  CircularProgress,
  Container
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import StackedAreaChart from '../../components/StackedAreaChart';
import LegendaStackedAreaGraph from './LegendaStackedAreaGraph';
import TableGeneralStudentReport from './TableGeneralStudentReport';
import LegendaReport from '../../components/LegendaReport';
import { CSVLink } from 'react-csv';
import GetAppIcon from '@material-ui/icons/GetApp';
import { withTheme } from 'styled-components';
import PopoverIcon from '../../components/PopoverIcon';
import InsufficientData from '../../components/InsufficientData';
import ChartLegend from '../../components/ChartLegend';
import Swal from 'sweetalert2';
import StackedBarChart from '../avalia/StackedBarChart';
import ReportGraphEssay from './ReportGraphEssay';
import BasicBarChart from './BasicBarChart';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import FilterRelatorioDre from '../avalia/FilterRelatorioDre.js';
import ReportPresenca from './ReportPresenca.js';
import { toast } from 'react-toastify';

const columnsHabilidade = [
  { id: 'habilidade', label: 'Habilidade', minWidth: 170, align: 'center' },
  { id: 'qtde_testada', label: 'Quantidade', minWidth: 170, align: 'center' },
  { id: 'qtde_acertos', label: 'Acertos', minWidth: 170, align: 'center' },
  {
    id: 'porc_acertos',
    label: 'Porc. Acertos',
    minWidth: 170,
    align: 'center'
  },
  { id: 'status', label: 'Status', minWidth: 170, align: 'center' }
];

const etapa_name = {
  2: 'EF 2º ano',
  3: 'EF 3º ano',
  4: 'EF 4º ano',
  5: 'EF 5º ano',
  6: 'EF 6º ano',
  7: 'EF 7º ano',
  8: 'EF 8º ano',
  9: 'EF 9º ano',
  11: 'EM 1ª série',
  12: 'EM 2ª série',
  13: 'EM 3ª série'
};

const disciplina_name = {
  1: 'Linguagens',
  2: 'Matemática',
  3: 'Ciências da Natureza',
  4: 'Ciências Humanas'
};

const disciplinaNameInputSelect = [
  { value: 1, label: 'Linguagens' },
  { value: 2, label: 'Matemática' },
  { value: 3, label: 'Ciências da Natureza' },
  { value: 4, label: 'Ciências Humanas' }
];

const etapaNameInputSelect = [
  { value: 2, label: 'EF 2º ano' },
  { value: 3, label: 'EF 3º ano' },
  { value: 4, label: 'EF 4º ano' },
  { value: 5, label: 'EF 5º ano' },
  { value: 6, label: 'EF 6º ano' },
  { value: 7, label: 'EF 7º ano' },
  { value: 8, label: 'EF 8º ano' },
  { value: 9, label: 'EF 9º ano' },
  { value: 11, label: 'EM 1ª série' },
  { value: 12, label: 'EM 2ª série' },
  { value: 13, label: 'EM 3ª série' }
];

const checkIsNotNull = (list, field) => {
  let response = false;
  list.map((obj) => {
    if (get(obj, field) !== null) {
      response = true;
    }
  });
  return response;
};
class ReportDrePage extends Component {
  state = {
    loading: false,
    downloadingPDF: false,
    downloadingCSV: false,
    relMicrodadosId: null,
    boletimData: {},
    habilidadeData: [],
    competenciaData: [],
    habilidadeDataSESI: [],
    competenciaDataSESI: [],
    disciplinaIDState: this.props.match.params.cd_disciplina,
    etapaIDState: this.props.match.params.nr_etapa,
    periodoIDState: this.props.match.params.periodoId,
    renderTable: this.props.match.params.periodoId == 3 ? 3 : 1,
    metadata: undefined,
    graphRedacaoBar: [],
    graphRedacaoCompetencia: [],
    dadosTCT: [],
    tableTCT: [],
    dadosBarChart: [],
    tableBarChart: [],
    dadosLineChart: undefined,
    dadosDreLine: undefined,
    graphRedacaoCompetenciaPie: undefined,
    basicBarChart: [],
    metadataAvalia: {}
  };

  constructor(props) {
    super(props);
    this.botaoSearchRef = React.createRef();
  }

  fetchMetadataAvalia() {
    axios.get(`${API_HOST}/params/param?model=avalia`).then((response) => {
      this.setState({ metadataAvalia: this.mapMetadataAvalia(response.data) });
    });
  }

  getParam(field) {
    const { metadataAvalia } = this.state;
    return get(metadataAvalia, field);
  }

  mapMetadataAvalia(metadata) {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.value;
    });
    return mapped;
  }

  handleDownloadCSV = () => {
    const dataISO = this.state.lastGeneratedDate;
    let formatBr = 'Arquivo não gerado';
    if (dataISO !== '') {
      const data = new Date(dataISO);
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      };

      formatBr = data.toLocaleDateString('pt-BR', options);
    }

    if (!this.state.downloadingCSV) {
      Swal.fire({
        title: `Data da última geração: ${
          formatBr === 'Invalid Date' ? '' : formatBr
        }`,
        showCancelButton: dataISO ? true : false,
        confirmButtonText: dataISO ? 'Gerar Novamente' : 'Gerar',
        cancelButtonText: 'Baixar Anterior',
        showConfirmButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.get_microdados_csv();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          const link = document.createElement('a');
          link.href = this.state.file_key;
          link.download = 'microdados.csv';
          link.click();
        }
      });
    }
  };

  fetchHabilidade = () => {
    const { filtrosRelatorios } = this.context;
    const params = {
      tipo: 'dre-habilidade',
      dre: filtrosRelatorios.dreId,
      disciplina_id: filtrosRelatorios.DisciplinaID,
      periodo_ano_id: filtrosRelatorios.periodoAno,
      nr_etapa: filtrosRelatorios.EtapaNumero
    };

    axios
      .get(
        `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_dre`,
        { params }
      )
      .then((res) => {
        this.setState({ habilidadeData: res.data });
      })
      .catch((err) => console.error(err));
  };

  fetchCompetencia = () => {
    const { filtrosRelatorios } = this.context;

    const params = {
      tipo: 'dre-competencia',
      dre: filtrosRelatorios.dreId
    };

    axios
      .get(
        `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_dre`,
        { params }
      )
      .then((res) => {
        this.setState({ competenciaData: res.data.data });
      })
      .catch((err) => console.error(err));
  };

  fetchHabilidadeSESI = () => {
    axios
      .get(
        `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_turma?tipo=dre-habilidade&etapa=12&turma=202200015482O4X81001&ano=1&escola=3000000`
      )
      .then((res) => {
        this.setState({ habilidadeDataSESI: res.data.data });
      })
      .catch((err) => console.error(err));
  };

  fetchCompetenciaSESI = () => {
    axios
      .get(
        `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_turma?tipo=dre-competencia&etapa=12&turma=202200015482O4X81001&ano=1&escola=3000000`
      )
      .then((res) => {
        this.setState({ competenciaDataSESI: res.data.data });
      })
      .catch((err) => console.error(err));
  };

  mapPeriodo = (d) => ({
    value: d.id,
    label: d.ds_periodo
  });

  fetchGraphEssayBar = async () => {
    const { filtrosRelatorios } = this.context;

    try {
      const params = {
        tipo: 'redacao-dr-bar',
        dre: filtrosRelatorios.dreId,
        disciplina_id: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        nr_etapa: filtrosRelatorios.EtapaNumero
      };
      const res = await axios.get(
        `${API_HOST}/avalia/estudante/get_notas_to_line_chart`,
        { params }
      );
      this.setState({ graphRedacaoBar: res.data });
    } catch (error) {
      console.error(error);
    }
  };

  fetchBasicBarChart = async () => {
    const { filtrosRelatorios } = this.context;
    try {
      const params = {
        tipo: 'dre-comparativo-media-dn-dr',
        dre: filtrosRelatorios.dreId,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        etapa: filtrosRelatorios.EtapaNumero
      };
      const res = await axios.get(
        `${API_HOST}/avalia/estudante/get_notas_to_chart`,
        { params }
      );
      this.setState({ basicBarChart: res.data });
    } catch (error) {
      console.error(error);
    }
  };

  fetchGraphEssayCompetenciaBar = async () => {
    const { filtrosRelatorios } = this.context;
    try {
      const params = {
        tipo: 'redacao-dr-stacked',
        dre: filtrosRelatorios.dreId,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        etapa: filtrosRelatorios.EtapaNumero
      };
      const res = await axios.get(
        `${API_HOST}/avalia/estudante/get_stacked_area_graph`,
        { params }
      );
      this.setState({ graphRedacaoCompetencia: res.data });
    } catch (error) {
      console.error(error);
    }
  };

  fetchDataBarChartTCT = () => {
    const { filtrosRelatorios } = this.context;
    const params = {
      tipo: 'dre-tct',
      etapa: filtrosRelatorios.EtapaNumero,
      dre: filtrosRelatorios.dreId,
      ano: filtrosRelatorios.periodoAno
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      .then((response) => {
        this.setState({ dadosTCT: response.data.data.slice(0, -1) });
        this.setState({
          tableTCT: response.data.data.slice(-1)[0]['data_label']
        });
      })
      .catch((err) => {
        console.error('ERROR', err);
      });
  };

  fetchDataBarChart = () => {
    const { filtrosRelatorios } = this.context;
    const params = {
      tipo: 'dre',
      etapa: filtrosRelatorios.EtapaNumero,
      dre: filtrosRelatorios.dreId,
      ano: filtrosRelatorios.periodoAno
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      .then((response) => {
        this.setState({ dadosBarChart: response.data.data.slice(0, -1) });
        this.setState({
          tableBarChart: response.data.data.slice(-1)[0]['data_label']
        });
      })
      .catch((err) => {});
  };

  fetchDataLineChart = () => {
    const { filtrosRelatorios } = this.context;

    const params = {
      tipo: 'escolas-all-disciplina',
      disciplina: filtrosRelatorios.DisciplinaID,
      dre: filtrosRelatorios.dreId,
      ano: filtrosRelatorios.periodoAno
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, { params })
      .then((response) => {
        this.setState({ dadosLineChart: response.data.data });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchDataDreLine = () => {
    const { filtrosRelatorios } = this.context;
    const params = {
      tipo: 'dre-escolas',
      etapa: filtrosRelatorios.EtapaNumero,
      dre: filtrosRelatorios.dreId,
      ano: filtrosRelatorios.periodoAno,
      disciplina: filtrosRelatorios.DisciplinaID
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      .then((response) => {
        this.setState({ dadosDreLine: response.data.data });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchGraphEssayCompetenciaPie = async () => {
    const { filtrosRelatorios } = this.context;
    try {
      const params = {
        tipo: 'redacao-dr-pie',
        dre: filtrosRelatorios.dreId,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        nr_etapa: filtrosRelatorios.EtapaNumero
      };
      const res = await axios.get(
        `${API_HOST}/avalia/estudante/get_stacked_area_graph`,
        { params }
      );
      this.setState({ graphRedacaoCompetenciaPie: res.data });
    } catch (error) {
      console.error(error);
    }
  };

  componentDidMount() {
    this.fetchMetadataAvalia();
  }

  componentDidUpdate(prevProps) {
    const currentContextState = this.context;
    if (
      currentContextState.filtrosRelatorios &&
      currentContextState.filtrosRelatorios.isFormSubmit
    ) {
      this.buttonRelatorio();
      this.context.setStateFilters({ isFormSubmit: false });
    }
  }

  buttonRelatorio = async () => {
    const { filtrosRelatorios, setStateFilters } = this.context;

    if (filtrosRelatorios.DisciplinaID != 8) {
      this.fetchBoletimData();
      this.fetchDataBarChartTCT();
      this.fetchDataLineChart();
      this.fetchDataBarChart();
      this.fetchBoletimData();
      this.fetchDataBarChartTCT();
      this.fetchDataLineChart();
      this.fetchDataBarChart();
      this.fetchDataDreLine();
      this.fetchTableData();
      this.fetchBasicBarChart();
      this.fetchTableRedeData();
      this.fetchBoletimDataDRe();
      this.fetchHabilidade();
      this.fetchCompetencia();
      this.fetchDataDots();
      this.fetchDre();
      this.fetchHabilidadeSESI();
      this.fetchCompetenciaSESI();
      this.fetchMetadata();
    }
    if (filtrosRelatorios.DisciplinaID == 8) {
      this.fetchPeriodoInput();
      this.fetchDataBarChartTCT();
      this.fetchGraphEssayBar();
      this.fetchGraphEssayCompetenciaBar();
      this.fetchBoletimDataDRe();
      this.fetchGraphEssayCompetenciaPie();
      this.fetchBasicBarChart();
    }
    setStateFilters({ fecth: true, fecthPresenca: false });
  };

  componentWillUnmount() {
    this.state.loading = true;
  }

  genDadosCSV = () => {
    const dados = [];
    this.state.distribuicaoProf.porc_acertos_dre &&
      this.state.distribuicaoProf.porc_acertos_dre.map((dado) => {
        dados.push({
          Proficiência: dado.name,
          '%': (dado.y * 100).toFixed(0) + ' %'
        });
      });
    return dados;
  };

  genPdf = async () => {
    this.setState({ downloadingPDF: true });
    const mediaProf = await html2canvas(
      document.getElementById('mediaProf')
    ).then(function (canvas) {
      return {
        image: canvas.toDataURL(),
        width: 600,
        pageBreak: 'after',
        style: {
          alignment: 'center'
        }
      };
    });

    const comparacaoProf = await html2canvas(
      document.getElementById('comparacaoProf')
    ).then(function (canvas) {
      return {
        image: canvas.toDataURL(),
        width: 600,
        pageBreak: 'after',
        style: {
          alignment: 'center'
        }
      };
    });

    const distribuicaoProf = await html2canvas(
      document.getElementById('distribuicaoProf')
    ).then(function (canvas) {
      return {
        image: canvas.toDataURL(),
        width: 600,
        pageBreak: 'after',
        style: {
          alignment: 'center'
        }
      };
    });

    const comparativoProf = await html2canvas(
      document.getElementById('comparativoProf')
    ).then(function (canvas) {
      return {
        image: canvas.toDataURL(),
        width: 300,
        style: {
          alignment: 'center'
        }
      };
    });

    const documentDefinition = {
      content: [mediaProf, comparacaoProf, distribuicaoProf, comparativoProf],
      defaultStyle: {
        font: 'NimbusSans'
      },
      pageSize: 'A4',
      pageOrientation: 'vertical',
      pageMargins: [0, 0, 0, 0]
    };
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.download();
    this.setState({ downloadingPDF: false });
  };

  fetchDre = () => {
    axios
      .get(`${API_HOST}/avalia/dre`)
      .then((res) => {
        const data = res.data.map((d) => ({
          value: d.id,
          label: d.dre_name,
          ...d
        }));
        this.fetchNivelProficiencia(data);
        this.fetchNivelProficienciaDn(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  sleep = (delay = 0) => {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  };

  fetchStatusMicrodados = async (id) => {
    await this.sleep(5e3);

    const params = { id: id };
    await axios
      .get(`${API_HOST}/avalia/microdados/get_microdados_status`, { params })
      .then((res) => {
        if (res.data.file_key) {
          const link = document.createElement('a');
          link.href = res.data.file_key;
          link.download = 'microdados.csv';
          link.click();

          this.setDownloading(false);
          this.fetchLastMicrodados();
        } else {
          this.fetchStatusMicrodados(id);
          this.setDownloading(true);
        }
      })
      .catch((err) => console.error(err));
  };

  fetchLastMicrodados = () => {
    const { filtrosRelatorios } = this.context;
    const params = {
      dre_id: filtrosRelatorios.dreId,
      periodo_ano_id: filtrosRelatorios.periodoAno
    };
    axios
      .get(`${API_HOST}/avalia/microdados/get_last_generated`, { params })
      .then((response) => {
        if (response.data && response.data.res) {
          this.setState({
            lastGeneratedDate: response.data.res.criado_em,
            file_key: response.data.res.file_key,
            statusCSV: response.data.res.status
          });
        }
      })
      .catch((err) => console.error(err));
  };

  get_microdados_csv = debounce(() => {
    const { filtrosRelatorios } = this.context;
    this.setDownloading(true);
    const payload = {
      dre_id: filtrosRelatorios.dreId,
      periodo_ano_id: filtrosRelatorios.periodoAno
    };
    axios
      .post(`${API_HOST}/avalia/microdados/get_microdados_csv`, { payload })
      .then((res) => {
        this.setState({ relMicrodadosId: res.data });
        this.fetchStatusMicrodados(res.data);
      })
      .catch((err) => console.error(err));
  }, 1000);

  fetchNivelProficiencia = (dreOptions) => {
    const { filtrosRelatorios, setStateFilters } = this.context;

    const dre_name = dreOptions.filter(
      (x) => x.id == filtrosRelatorios.dreId
    )[0].label;
    const params = {
      dre: dre_name,
      prova_a_cd_disciplina: filtrosRelatorios.DisciplinaID,
      periodo_ano_id: filtrosRelatorios.periodoAno,
      etapa_escolar: filtrosRelatorios.EtapaNumero,
      tipo: 'dre'
    };
    axios
      .get(`${API_HOST}/avalia/distribuicao_percentual/get_porc_acertos`, {
        params
      })
      .then((res) => {
        this.setState({ distribuicaoProf: res.data });
      })
      .catch((err) => console.error(err));
  };

  fetchNivelProficienciaDn = (dreOptions) => {
    const { filtrosRelatorios } = this.context;

    const params = {
      prova_a_cd_disciplina: filtrosRelatorios.DisciplinaID,
      periodo_ano_id: filtrosRelatorios.periodoAno,
      etapa_escolar: filtrosRelatorios.EtapaNumero,
      tipo: 'dn'
    };
    axios
      .get(`${API_HOST}/avalia/distribuicao_percentual/get_porc_acertos`, {
        params
      })
      .then((res) => {
        this.setState({ distribuicaoProfdn: res.data });
      })
      .catch((err) => console.error(err));
  };

  fetchMetadata = () => {
    axios.get(`${API_HOST}/params/param?name=Escala`).then((response) => {
      this.setState({
        metadata: response.data[0] && response.data[0].requireness
      });
    });
  };

  fetchBoletimDataDRe = () => {
    const { filtrosRelatorios } = this.context;

    const dreId = filtrosRelatorios.dreId;
    axios
      .get(`${API_HOST}/avalia/dre?id=${dreId}`)
      .then((res) => {
        this.setState({ dre_nome: res.data[0] });
        this.fetchLastMicrodados();
      })
      .catch((err) => console.error(err));
  };

  fetchBoletimData = () => {
    this.setState({ loading: false });
    const { filtrosRelatorios } = this.context;
    const cd_disciplina = filtrosRelatorios.DisciplinaID;
    const nr_etapa = filtrosRelatorios.EtapaNumero;
    const periodoId = filtrosRelatorios.periodoAno;
    axios
      .get(
        `${API_HOST}/avalia/boletim_mt/grafico_mapa?CD_DISCIPLINA=${cd_disciplina}&NR_ETAPA=${nr_etapa}&PERIODO_ANO_ID=${periodoId}`
      )
      .then((res) => {
        this.fetchPeriodoData();
        this.setState({ loading: true, boletimData: res.data });
        this.fetchPeriodoInput(res.data);
      })
      .catch((err) => console.error(err));
  };

  fetchDataDots = () => {
    const { filtrosRelatorios, setStateFilters } = this.context;
    const tipo = 'avaliamt';
    const params = {
      tipo: 'dr',
      ano: filtrosRelatorios.periodoAno,
      disciplina: filtrosRelatorios.DisciplinaID,
      dre: filtrosRelatorios.dreId,
      ambiente: tipo
    };
    axios
      .get(`${API_HOST}/avalia/boletim_mt/get_graph_dat`, { params })
      .then((res) => {
        setStateFilters({ dn_dots: res.data.data, dataDot: res.data });
      })
      .catch((err) => console.error(err));
  };

  fetchTableData = () => {
    const { filtrosRelatorios } = this.context;

    const cd_disciplina = filtrosRelatorios.DisciplinaID;
    const params = {
      cd_periodo: filtrosRelatorios.periodoAno
    };
    axios
      .get(
        `${API_HOST}/avalia/presenca_dre/${cd_disciplina}/get_presenca_dre`,
        { params }
      )
      .then((res) => {
        this.setState({ presencaDreData: res.data.dre });
      })
      .catch((err) => console.error(err));
  };

  fetchTableRedeData = () => {
    const { filtrosRelatorios } = this.context;

    const cd_disciplina = filtrosRelatorios.DisciplinaID;
    axios
      .get(
        `${API_HOST}/avalia/presenca_rede/${cd_disciplina}/get_presenca_rede`
      )
      .then((res) => {
        this.setState({ presencaRedeData: res.data.rede });
      })
      .catch((err) => console.error(err));
  };

  fetchPeriodoData = () => {
    const { filtrosRelatorios } = this.context;
    const periodoId = filtrosRelatorios.periodo;
    axios.get(`${API_HOST}/avalia/periodo?id=${periodoId}`).then((res) => {
      this.setState({ periodoData: res.data[0] });
    });
  };

  fetchPeriodoInput = () => {
    axios.get(`${API_HOST}/avalia/periodo`).then((res) => {
      const data = res.data.map(this.mapPeriodo);

      this.setState({ periodoOptions: data });
    });
  };

  setDownloading = (value) => {
    this.setState({ downloadingCSV: value });
  };

  count = 0;

  setShoundFetchData = (value) => {
    if (this.count == value) {
      this.count++;
      return true;
    } else {
      return false;
    }
  };

  render() {
    const {
      metadata,
      periodoData,
      habilidadeData,
      dre_nome,
      downloadingPDF,
      downloadingCSV,
      graphRedacaoBar,
      graphRedacaoCompetencia,
      dadosTCT,
      tableTCT,
      dadosBarChart,
      tableBarChart,
      dadosLineChart,
      dadosDreLine,
      graphRedacaoCompetenciaPie
    } = this.state;
    const { filtrosRelatorios, setStateFilters } = this.context;
    const infoHeader = filtrosRelatorios;
    const { history } = this.props;
    const host = window.location.host;

    const Accordion = withStyles({
      root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
          borderBottom: 0
        },
        '&:before': {
          display: 'none'
        },
        '&$expanded': {
          marginTop: '10px',
          marginBottom: '10px',
          margin: 'auto'
        },
        '& .MuiPaper-root': {
          backgroundColor: 'none'
        }
      },
      expanded: {}
    })(MuiAccordion);

    const AccordionSummary = withStyles({
      root: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: this.props.theme.primary,
        border: 'none',
        borderRadius: '16px',
        height: '42px',
        boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
        marginBottom: '10px',
        '&$expanded': {
          minHeight: 56
        }
      },
      content: {
        '&$expanded': {
          margin: '12px 0'
        }
      },
      expanded: {}
    })(MuiAccordionSummary);

    const AccordionDetails = withStyles((theme) => ({
      root: {
        backgroundColor: '#FFFFFF',
        padding: theme.spacing(2),
        border: '1px solid #F7F7F7',
        borderRadius: '8px'
      }
    }))(MuiAccordionDetails);

    const ColorPDFButton = withStyles(() => ({
      root: {
        width: 'auto',
        minWidth: '70px',
        height: '35px',
        backgroundColor: '#D02211',
        borderRadius: '53px',
        border: `1px solid #D02211`,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        color: '#fff',
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: '#a8170a'
        }
      }
    }))(IconButton);

    const legenda = 'Rede de Ensino';
    const isRj = (this.getParam('avalia.estado') || '').toLowerCase() === 'rj';
    const dreOrDr = isRj ? 'DRP' : 'DRE';
    const areaConhecimentoLabel = isRj ? 'disciplina' : 'área do conhecimento';
    const disciplineFieldLabel = isRj
      ? 'Componente Curricular/Disciplina'
      : 'Componente Curricular/Área do Conhecimento';
    const redeOrDn = 'REDE';
    const reportTitle = isRj
      ? 'Relatório da Diretoria Regional de Educação (DRP)'
      : 'Relatório da Diretoria Regional de Educação (DRE)';

    return (
      <Container style={{ width: 'fit-content' }} maxWidth="lg">
        <Form>
          <div
            className="container"
            style={{
              width: '100%',
              border: '1px solid #d6d6d6',
              backgroundColor: '#F7F7F7',
              borderRadius: '40px',
              padding: '2%',
              marginTop: '2rem'
            }}
          >
            <Grid container spacing={2}>
              <Grid item container spacing={0}>
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    <label
                      style={{
                        fontFamily: 'Quicksand',
                        fontSize: '30px',
                        fontWeight: '700',
                        color: '#333333'
                      }}
                    >
                      {reportTitle}
                    </label>
                  </Grid>

                  <Grid item xs={12}>
                    <label
                      style={{
                        fontFamily: 'Quicksand',
                        fontWeight: '500',
                        color: '#333333'
                      }}
                    >
                      {legenda}
                    </label>
                  </Grid>

                  <Grid item xs={12}>
                    <hr
                      style={{
                        width: '100%',
                        height: '1px',
                        background: 'rgb(190, 190, 190)'
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item container spacing={0}>
                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                  <FilterRelatorioDre
                    dre={true}
                    buttonRelatorio={this.buttonRelatorio}
                  ></FilterRelatorioDre>

                  {filtrosRelatorios.fetch && (
                    <Grid
                      item
                      container
                      xs={1}
                      justifyContent="flex-end"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '1rem'
                      }}
                    >
                      <ColorPDFButton
                        style={{ outline: 'none' }}
                        onClick={() => {
                          this.genPdf();
                        }}
                      >
                        {!downloadingPDF ? (
                          <>
                            PDF
                            <GetAppIcon
                              style={{ color: '#FFFFFF', fontSize: '16px' }}
                            />
                          </>
                        ) : (
                          <CircularProgress color="inherit" size={16} />
                        )}
                      </ColorPDFButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {filtrosRelatorios.fecth && (
                <>
                  {filtrosRelatorios.DisciplinaID == 8 ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{ background: 'none', marginTop: '1rem' }}
                      >
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                              />
                            }
                            aria-controls="panel1d-content"
                            id="panel1d-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginBottom: '2px',
                                  marginRight: '5px'
                                }}
                              >
                                Comparativo entre Média da Rede e Média
                                Regional:
                              </label>
                              <PopoverIcon
                                disc={`O gráfico faz uma comparação entre o média das notas relacionadas ao filtro </br>
                            aplicado entre a Rede de ensino e as Regionais.`}
                                color={this.props.theme.secondary}
                              ></PopoverIcon>
                            </div>
                          </AccordionSummary>

                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item container xs={12} sm={12} md={12}>
                                <HeaderDr
                                  disciplineLabel={disciplineFieldLabel}
                                  discipline={
                                    disciplina_name[
                                      `${infoHeader.DisciplinaID}`
                                    ]
                                  }
                                  dreAndMunicipio={get(dre_nome, 'dre_name')}
                                  periodoAno={get(periodoData, 'ds_periodo')}
                                  dreOrDr={dreOrDr}
                                />
                              </Grid>
                              <Grid item container xs={12} sm={12} md={12}>
                                <Grid item xs={12}></Grid>
                                <Grid item container xs={12} sm={12} md={12}>
                                  <Grid item xs={12}></Grid>
                                  <Grid item xs={12}>
                                    <BasicBarChart
                                      data={this.state.basicBarChart}
                                      title={''}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '1.0rem', background: 'none' }}
                        id="redacaoMedia"
                      >
                        <Accordion
                          defaultExpanded
                          style={{ marginTop: '1rem', width: '100%' }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                              />
                            }
                            aria-controls="redacaoMedia-content"
                            id="redacaoMedia-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginBottom: '2px',
                                  marginRight: '5px'
                                }}
                              >
                                Gráfico Notas por Competências
                              </label>
                              <HelpOutlinedIcon
                                style={{
                                  // fontSize: '19px',
                                  color: this.props.theme.secondary
                                }}
                              />
                            </div>
                          </AccordionSummary>
                          <Grid item container xs={12} sm={12} md={12}>
                            <HeaderDr
                              disciplineLabel={disciplineFieldLabel}
                              schoolYear={etapa_name[`${infoHeader.nr_etapa}`]}
                              discipline={
                                disciplina_name[`${infoHeader.DisciplinaID}`]
                              }
                              dreAndMunicipio={get(dre_nome, 'dre_name')}
                              dreOrDr={dreOrDr}
                            />
                          </Grid>
                          {graphRedacaoCompetencia.data && (
                            <div>
                              <StackedBarChart
                                dados={graphRedacaoCompetencia.data}
                                tituloCompleto={''}
                                media={true}
                              />
                              <StackedBarChart
                                dados={graphRedacaoCompetencia.data}
                                tituloCompleto={''}
                              />
                            </div>
                          )}
                          {/* NAO APAGAR! ESSE TRECHO DEVE SER MANTIDO PARA FACILITAR ALTERACOES FUTURAS PELO SESI. */}
                          {/* <CompetenciasPieCharts
                        data={graphRedacaoCompetenciaPie}
                      /> */}
                          <StackedBarChart
                            dados={graphRedacaoCompetencia.data}
                            tituloCompleto={''}
                          />
                        </Accordion>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '1.0rem', background: 'none' }}
                        id="redacaoMedia"
                      >
                        <Accordion
                          defaultExpanded
                          style={{ marginTop: '1rem', width: '100%' }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                              />
                            }
                            aria-controls="redacaoMedia-content"
                            id="redacaoMedia-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginBottom: '2px',
                                  marginRight: '5px'
                                }}
                              >
                                Gráfico Estudantes por Proficiência
                              </label>
                              <HelpOutlinedIcon
                                style={{
                                  // fontSize: '19px',
                                  color: this.props.theme.secondary
                                }}
                              />
                            </div>
                          </AccordionSummary>
                          <Grid item container xs={12} sm={12} md={12}>
                            <HeaderDr
                              disciplineLabel={disciplineFieldLabel}
                              schoolYear={etapa_name[`${infoHeader.nr_etapa}`]}
                              discipline={
                                disciplina_name[`${infoHeader.DisciplinaID}`]
                              }
                              dreAndMunicipio={get(dre_nome, 'dre_name')}
                              dreOrDr={dreOrDr}
                            />
                          </Grid>
                          <div>
                            <ReportGraphEssay
                              data={graphRedacaoBar}
                              title={''}
                              type={'column'}
                            />
                          </div>
                        </Accordion>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{ background: 'none', marginTop: '1rem' }}
                      >
                        {(filtrosRelatorios.EtapaNumero !== '13' &&
                          !(
                            filtrosRelatorios.periodoAno === '4' &&
                            (filtrosRelatorios.DisciplinaID === '3' ||
                              filtrosRelatorios.DisciplinaID === '4') &&
                            (filtrosRelatorios.EtapaNumero === '2' ||
                              filtrosRelatorios.EtapaNumero === '5')
                          )) ||
                        filtrosRelatorios.periodoAno === '5' ? (
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={
                                <ArrowDropDownIcon
                                  style={{
                                    fontSize: '2.5rem',
                                    color: '#FFFFFF'
                                  }}
                                />
                              }
                              aria-controls="panel1d-content"
                              id="panel1d-header"
                            >
                              <div
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <label
                                  style={{
                                    color: '#FFFFFF',
                                    fontFamily: 'Quicksand',
                                    fontWeight: '700',
                                    // fontSize: '19px',
                                    marginBottom: '2px',
                                    marginRight: '5px'
                                  }}
                                >
                                  Dispersão de proficiência média do {dreOrDr} em
                                  relação às faixas de proficiência
                                </label>
                                <PopoverIcon
                                  disc={`O gráfico analisa a dispersão de proficiência do ${dreOrDr} no mapa de escala por componente curricular, <br>
                                  sendo possível visualizar também informações por etapa escolar. <br>
                                  Ele também faz uma comparação entre a Rede de ensino e Regionais.`}
                                ></PopoverIcon>
                              </div>
                            </AccordionSummary>

                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item container xs={12} sm={12} md={12}>
                                  <HeaderDr
                                    disciplineLabel={disciplineFieldLabel}
                                    discipline={
                                      disciplina_name[
                                        `${infoHeader.DisciplinaID}`
                                      ]
                                    }
                                    dreAndMunicipio={get(dre_nome, 'dre_name')}
                                    periodoAno={get(periodoData, 'ds_periodo')}
                                    dreOrDr={dreOrDr}
                                  />
                                </Grid>

                                <Grid item container xs={12} sm={12} md={12}>
                                  <Grid item xs={12}>
                                    <p
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        fontFamily: 'Quicksand',
                                        color: '#565656'
                                      }}
                                    ></p>
                                  </Grid>
                                  <Grid item xs={12}>
                                    {filtrosRelatorios.dn_dots &&
                                    checkIsNotNull(
                                      filtrosRelatorios.dn_dots,
                                      'nota'
                                    ) ? (
                                      <div
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          marginBottom: '3rem'
                                        }}
                                      >
                                        <div
                                          className="dispersao"
                                          style={{ display: 'flex' }}
                                        >
                                          <StackedAreaChart
                                            metadata={metadata}
                                            dataDot={filtrosRelatorios.dataDot}
                                            defaultData={
                                              filtrosRelatorios.dn_dots
                                            }
                                            disc={infoHeader.DisciplinaID}
                                            tipo={filtrosRelatorios.periodoAno}
                                            pontos={true}
                                            useBase={true}
                                            bottom={''}
                                            tourSelectorGrafico={'gráfico'}
                                            tourSelectorlegenda={'legenda'}
                                          />
                                          <LegendaStackedAreaGraph
                                            tipo={'dr'}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          height: 'auto',
                                          width: '100%'
                                        }}
                                      >
                                        <InsufficientData />
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        ) : (
                          <></>
                        )}
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        style={{ background: 'none', marginTop: '1rem' }}
                      >
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                              />
                            }
                            aria-controls="panel1d-content"
                            id="panel1d-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginBottom: '2px',
                                  marginRight: '5px'
                                }}
                              >
                                Comparativo entre Média da Rede e Média
                                Regional:
                              </label>
                              <PopoverIcon
                                disc={`O gráfico faz uma comparação entre o média das notas relacionadas ao filtro </br>
                            aplicado entre a Rede de ensino e as Regionais.`}
                                color={this.props.theme.secondary}
                              ></PopoverIcon>
                            </div>
                          </AccordionSummary>

                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item container xs={12} sm={12} md={12}>
                                <HeaderDr
                                  disciplineLabel={disciplineFieldLabel}
                                  discipline={
                                    disciplina_name[
                                      `${infoHeader.DisciplinaID}`
                                    ]
                                  }
                                  dreAndMunicipio={get(dre_nome, 'dre_name')}
                                  periodoAno={get(periodoData, 'ds_periodo')}
                                  dreOrDr={dreOrDr}
                                />
                              </Grid>
                              <Grid item container xs={12} sm={12} md={12}>
                                <Grid item xs={12}>
                                  <p
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '400',
                                      fontFamily: 'Quicksand',
                                      color: '#565656'
                                    }}
                                  ></p>
                                </Grid>
                                <Grid item container xs={12} sm={12} md={12}>
                                  <Grid item xs={12}>
                                    <p
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        fontFamily: 'Quicksand',
                                        color: '#565656'
                                      }}
                                    ></p>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <BasicBarChart
                                      data={this.state.basicBarChart}
                                      title={''}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '.7rem', background: 'none' }}
                        id="comparacaoProf"
                      >
                        <Accordion
                          defaultExpanded
                          style={{
                            backgroundColor: 'none'
                          }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#fff' }}
                              />
                            }
                            aria-controls="panel1d-content"
                            id="panel1d-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                className="mt-2"
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginRight: '5px'
                                }}
                              >
                                Comparação de proficiência entre {dreOrDr} e {redeOrDn}
                              </label>
                              <PopoverIcon
                                disc="O gráfico de barras de comparação de proficiência entre escolas por componente curricular<br>
                          informa a média de proficiência entre as escolas, comparando a média regional e nacional."
                                color={this.props.theme.secondary}
                              ></PopoverIcon>
                            </div>
                          </AccordionSummary>
                          <Grid item container xs={12} sm={12} md={12}>
                            <div
                              style={{
                                marginTop: '1.0rem',
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <div
                                style={{
                                  width: '98%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              ></div>
                            </div>
                          </Grid>

                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item container xs={12} sm={12} md={12}>
                                <HeaderDr
                                  disciplineLabel={disciplineFieldLabel}
                                  schoolYear={
                                    etapa_name[`${infoHeader.nrEtapa}`]
                                  }
                                  discipline={
                                    disciplina_name[
                                      `${infoHeader.DisciplinaID}`
                                    ]
                                  }
                                  dreAndMunicipio={get(dre_nome, 'dre_name')}
                                  dreOrDr={dreOrDr}
                                />
                              </Grid>
                              <Grid item container xs={12} sm={12} md={12}>
                                <Grid item xs={12}>
                                  <p
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '400',
                                      fontFamily: 'Quicksand',
                                      color: '#565656'
                                    }}
                                  ></p>
                                </Grid>
                                <Grid item xs={12}>
                                  {dadosDreLine && (
                                    <ReportGraphLine
                                      tipo={'dre-escolas'}
                                      relatorio={'dre'}
                                      dre={filtrosRelatorios.dreId}
                                      etapa={filtrosRelatorios.EtapaNumero}
                                      disciplina={
                                        filtrosRelatorios.DisciplinaID
                                      }
                                      ano={filtrosRelatorios.periodoAno}
                                      externalData={dadosDreLine}
                                      shoudFetch={false}
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>

                      {this.state.distribuicaoProf &&
                        this.state.distribuicaoProf.porc_acertos_dre && (
                          <Grid item xs={12} id="distribuicaoProf">
                            <Accordion
                              defaultExpanded
                              style={{
                                backgroundColor: 'none',
                                marginTop: '1rem'
                              }}
                            >
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#FFFFFF'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  <label
                                    style={{
                                      color: '#FFFFFF',
                                      fontFamily: 'Quicksand',
                                      fontWeight: '700',
                                      // fontSize: '19px',
                                      marginBottom: '2px',
                                      marginRight: '5px'
                                    }}
                                  >
                                    Distribuição por proficiência
                                  </label>
                                  <PopoverIcon
                                    disc=""
                                    color={this.props.theme.secondary}
                                  ></PopoverIcon>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <HeaderDr
                                      disciplineLabel={disciplineFieldLabel}
                                      schoolYear={
                                        etapa_name[`${infoHeader.nr_etapa}`]
                                      }
                                      periodoAno={get(
                                        periodoData,
                                        'ds_periodo'
                                      )}
                                      discipline={
                                        disciplina_name[
                                          `${infoHeader.DisciplinaID}`
                                        ]
                                      }
                                      dreOrDr={dreOrDr}
                                    />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                      }}
                                    >
                                      {checkIsNotNull(
                                        this.state.distribuicaoProf
                                          .porc_acertos_dre,
                                        'y'
                                      ) && this.state.distribuicaoProfdn ? (
                                        <div className="graphic-prof-dn">
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'center',
                                              marginBottom: '20px'
                                            }}
                                          >
                                            <h1>
                                              Distribuição dos alunos por faixa
                                              de proficiência
                                            </h1>
                                          </div>
                                          <div
                                            className="distribuicao"
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-around'
                                            }}
                                          >
                                            <div style={{ width: '450px' }}>
                                              <ChartLegend title={"Proficiência Regional"} />
                                              <ComplexPieChart
                                                data={
                                                  this.state.distribuicaoProf
                                                    .porc_acertos_dre
                                                }
                                                width={450}
                                                height={400}
                                              />
                                            </div>
                                            <div style={{ width: '450px' }}>
                                              <ChartLegend title={`Proficiência da Rede de Ensino`} />
                                              <ComplexPieChart
                                                data={
                                                  this.state.distribuicaoProfdn
                                                    .porc_acertos_dn
                                                }
                                                width={450}
                                                height={400}
                                              />
                                            </div>
                                          </div>
                                          <LegendaReport
                                            type={'dre'}
                                            data={this.state.distribuicaoProf}
                                            dreOrDr={dreOrDr}
                                            data1={
                                              this.state.distribuicaoProfdn
                                            }
                                            periodo={
                                              filtrosRelatorios.periodoAno
                                            }
                                            ano={infoHeader.EtapaNumero}
                                            disciplina={infoHeader.DisciplinaID}
                                            range_proficiencia={
                                              this.state.distribuicaoProf
                                                .range_proficiencia
                                            }
                                          />
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'center',
                                              marginTop: '15px'
                                            }}
                                          >
                                            <Button>
                                              <CSVLink
                                                data={this.genDadosCSV()}
                                                filename={
                                                  'Distribuição por grupos de proficiência'
                                                }
                                              >
                                                Baixar gráfico em CSV
                                              </CSVLink>
                                            </Button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            height: 'auto',
                                            width: '100%'
                                          }}
                                        >
                                          <InsufficientData />
                                        </div>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        )}

                      <Grid item container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ background: 'none', marginTop: '1.0rem' }}
                          id="mediaProf"
                        >
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={
                                <ArrowDropDownIcon
                                  style={{
                                    fontSize: '2.5rem',
                                    color: '#FFFFFF'
                                  }}
                                />
                              }
                              aria-controls="panel1d-content"
                              id="panel1d-header"
                            >
                              <div
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <label
                                  style={{
                                    color: '#FFFFFF',
                                    fontFamily: 'Quicksand',
                                    fontWeight: '700',
                                    // fontSize: '19px',
                                    marginBottom: '2px',
                                    marginRight: '5px'
                                  }}
                                >
                                  Média de proficiência do {dreOrDr} por {areaConhecimentoLabel}
                                </label>
                                <PopoverIcon
                                  disc={`O relatório compara as escolas e ${areaConhecimentoLabel}, tanto por etapa escolar, quanto por turma.<br>
                            O primeiro gráfico informa a média de proficiência do ${dreOrDr} por ${areaConhecimentoLabel},<br>
                            mensurado no desempenho com a menor nota, nota média e maior nota.`}
                                  color={this.props.theme.secondary}
                                ></PopoverIcon>
                              </div>
                            </AccordionSummary>

                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item container xs={12} sm={12} md={12}>
                                  <HeaderDr
                                    disciplineLabel={disciplineFieldLabel}
                                    schoolYear={
                                      etapa_name[`${infoHeader.nr_etapa}`]
                                    }
                                    periodoAno={get(periodoData, 'ds_periodo')}
                                    dreAndMunicipio={get(dre_nome, 'dre_name')}
                                    dreOrDr={dreOrDr}
                                  />
                                </Grid>

                                <Grid item container xs={12} sm={12} md={12}>
                                  <Grid item xs={12}>
                                    <p
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        fontFamily: 'Quicksand',
                                        color: '#565656'
                                      }}
                                    ></p>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <ComplexBarChart
                                      tituloCompleto={`Desempenho médio do ${dreOrDr} por ${areaConhecimentoLabel}`}
                                      tipo={'dre'}
                                      shoudFetch={false}
                                      externalData={dadosBarChart}
                                      externalTable={tableBarChart}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </Grid>
                      </Grid>

                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={
                            <ArrowDropDownIcon
                              style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                            />
                          }
                          aria-controls="panel1d-content"
                          id="panel1d-header"
                        >
                          <div style={{ width: '100%', display: 'flex' }}>
                            <label
                              style={{
                                color: '#FFFFFF',
                                fontFamily: 'Quicksand',
                                fontWeight: '700',
                                // fontSize: '19px',
                                marginBottom: '2px',
                                marginRight: '5px'
                              }}
                            >
                              Comparativo de nível de proficiência entre escolas
                              por Componente Curricular
                            </label>
                            <PopoverIcon
                              disc="O gráfico comparativo de nível de proficiência entre escolas por componente curricular faz uma média <br>
                             do desempenho de todas as escolas por ano escolar,levando em consideração as áreas de conhecimento. <br>
                              Abaixo do gráfico há uma tabela,ela traduz o gráfico de linhas e facilita sua interpretação."
                              color={this.props.theme.secondary}
                            ></PopoverIcon>
                          </div>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Grid container spacing={2}>
                            <Grid item container xs={12} sm={12} md={12}>
                              <HeaderDr
                                disciplineLabel={disciplineFieldLabel}
                                periodoAno={get(periodoData, 'ds_periodo')}
                                discipline={
                                  disciplina_name[`${infoHeader.DisciplinaID}`]
                                }
                                dreAndMunicipio={get(dre_nome, 'dre_name')}
                                dreOrDr={dreOrDr}
                              />
                            </Grid>

                            <Grid item container xs={12} sm={12} md={12}>
                              <Grid item xs={12}>
                                <p
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    fontFamily: 'Quicksand',
                                    color: '#565656'
                                  }}
                                ></p>
                              </Grid>
                              <Grid item xs={12}>
                                <ComplexLineChart
                                  tituloCompleto={
                                    'Média de desempenho das escolas por Série/Ano'
                                  }
                                  titulo={'Escolas'}
                                  externalData={dadosLineChart}
                                  tipo={'escolas-all-disciplina'}
                                  shoudFetch={false}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '1.0rem', background: 'none' }}
                        id="comparativoProf"
                      >
                        <Accordion
                          defaultExpanded
                          style={{ marginTop: '1rem', width: '100%' }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ArrowDropDownIcon
                                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                              />
                            }
                            aria-controls="panel1d-content"
                            id="panel1d-header"
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <label
                                style={{
                                  color: '#FFFFFF',
                                  fontFamily: 'Quicksand',
                                  fontWeight: '700',
                                  // fontSize: '19px',
                                  marginBottom: '2px',
                                  marginRight: '5px'
                                }}
                              >
                                Relatórios por Habilidades
                              </label>
                              <HelpOutlinedIcon
                                style={{
                                  // fontSize: '19px',
                                  color: this.props.theme.secondary
                                }}
                              />
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid item container xs={12} sm={12} md={12}>
                              <Grid item xs={12}>
                                <TableGeneralStudentReport
                                  columns={columnsHabilidade}
                                  rows={habilidadeData}
                                  pagination={true}
                                  tourSelector="tabela-habilidade"
                                />
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </>
                  )}
                </>
              )}

              {filtrosRelatorios.fecthPresenca && <ReportPresenca />}
            </Grid>
          </div>
        </Form>
      </Container>
    );
  }
}

ReportDrePage.contextType = FilterRelatorioContext;
export default withTheme(ReportDrePage);
